import { gql } from 'graphql-request'

export namespace CorporateLeadMutations {
  export function createCorporateLead() {
    return gql`
      mutation createCorporateLead($corporateLead: CorporateLeadInsertMutation) {
        createCorporateLead(corporateLead: $corporateLead) {
          id
          createdAt
          firstName
          lastName
          companyName
          email
          phone
          numberOfUnits
        }
      }
    `
  }
}
